import Api from "@/api/api";
import { iniciarRequisicao, logout } from "@/helpers";

const state = {
  drawer: false,
  items_drawer: []
}

const getters = {
  GET_DRAWER(state) { return state.drawer },
  GET_ITEMS_DRAWER(state) { return state.items_drawer },
}

const mutations = {
  SET_DRAWER(state, valor) { state.drawer = valor; },
  SET_ITEMS_DRAWER(state, valor) { state.items_drawer = valor; },
}

const actions = {
  async atualizarMenuParaInicial({ commit }, rota) {
    const headers = iniciarRequisicao();
    return await Api.get("/parametrizacao/menu", { headers })
      .then(resp => {
        const { token, menu } = resp.data;

        localStorage.setItem("token", token);

        menu.map(m => {
          m.ativo = (m.url == rota);
          const parse = JSON.parse(m.items);
          m.items = parse[0] == null ? [] : parse;
          return m;
        });

        commit('SET_ITEMS_DRAWER', menu);
      })
      .catch(() => logout());
  },

  async atualizarMenuParaAreaDeUsuario({ commit }, rota) {
    const headers = iniciarRequisicao();
    return await Api.get("/parametrizacao/menu/usuario", { headers })
      .then(resp => {
        const { token, menu } = resp.data;

        localStorage.setItem("token", token);

        menu.map(m => {
          m.ativo = (m.url == rota);
          const parse = JSON.parse(m.items);
          m.items = parse[0] == null ? [] : parse;
          return m;
        });

        commit('SET_ITEMS_DRAWER', menu);
      })
      .catch(() => logout());
  },

  async atualizarMenuParaAreaDeFornecedor({ commit }, rota) {
    const headers = iniciarRequisicao();
    return await Api.get("/parametrizacao/menu/fornecedor", { headers })
      .then(resp => {
        const { token, menu } = resp.data;

        localStorage.setItem("token", token);

        menu.map(m => {
          m.ativo = (m.url == rota);
          const parse = JSON.parse(m.items);
          m.items = parse[0] == null ? [] : parse;
          return m;
        });

        commit('SET_ITEMS_DRAWER', menu);
      })
      .catch(() => logout());
  },

  async atualizarMenuParaAreaDeFilial({ commit }, rota) {
    const headers = iniciarRequisicao();
    return await Api.get("/parametrizacao/menu/filial", { headers })
      .then(resp => {
        const { token, menu } = resp.data;

        localStorage.setItem("token", token);

        menu.map(m => {
          m.ativo = (m.url == rota);
          const parse = JSON.parse(m.items);
          m.items = parse[0] == null ? [] : parse;
          return m;
        });

        commit('SET_ITEMS_DRAWER', menu);
      })
      .catch(() => logout());
  },

  async atualizarMenuParaAreaDeDistribuicao({ commit }, rota) {
    const headers = iniciarRequisicao();
    return await Api.get("/parametrizacao/menu/distribuicao", { headers })
      .then(resp => {
        const { token, menu } = resp.data;

        localStorage.setItem("token", token);

        menu.map(m => {
          m.ativo = (m.url == rota);
          const parse = JSON.parse(m.items);
          m.items = parse[0] == null ? [] : parse;
          return m;
        });

        commit('SET_ITEMS_DRAWER', menu);
      })
      .catch(() => logout());
  },

  async atualizarMenuParaAreaDeCompras({ commit }, rota) {
    const headers = iniciarRequisicao();
    return await Api.get("/parametrizacao/menu/compra", { headers })
      .then(resp => {
        const { token, menu } = resp.data;

        localStorage.setItem("token", token);

        menu.map(m => {
          m.ativo = (m.url == rota);
          const parse = JSON.parse(m.items);
          m.items = parse[0] == null ? [] : parse;
          return m;
        });

        commit('SET_ITEMS_DRAWER', menu);
      })
      .catch(() => logout());
  },
}

export default { namespaced: true, state, mutations, getters, actions }
